import { render, staticRenderFns } from "./Kho-HeaderList-KhoHang.vue?vue&type=template&id=1de24b97&scoped=true&"
import script from "./Kho-HeaderList-KhoHang.vue?vue&type=script&lang=js&"
export * from "./Kho-HeaderList-KhoHang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de24b97",
  null
  
)

export default component.exports